export default __webpack_public_path__ + "static/media/spacer-block-thumbnail-dark.c6aa0891.svg";